export default __webpack_public_path__ + "media/icons/user-testing-93ec94c1.svg";